var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.99992 11.6666C12.3011 11.6666 14.1666 9.80117 14.1666 7.49998C14.1666 5.19879 12.3011 3.33331 9.99992 3.33331C7.69873 3.33331 5.83325 5.19879 5.83325 7.49998C5.83325 9.80117 7.69873 11.6666 9.99992 11.6666ZM9.99992 11.6666C6.31802 11.6666 3.33325 13.9052 3.33325 16.6666M9.99992 11.6666C13.6818 11.6666 16.6666 13.9052 16.6666 16.6666",
    stroke: "#9599A1",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8e66bc8f580edf34ce7eb900b93fdea7.svg";
export { ForwardRef as ReactComponent };